module.exports = __webpack_public_path__ + "static/img/word.8cd1cef4.png";